import { useEffect, useState } from "react";
import api from "../lib/api";
import LandingHeader from "./landing/LandingHeader";
import Hero from "./landing/Hero";
import ReturnsTeaser from "./landing/ReturnsTeaser";
import MembershipProtocol from "./landing/MembershipProtocol";
import AccessVectors from "./landing/AccessVectors";
import WhatWeDoNotPublish from "./landing/WhatWeDoNotPublish";
import ContactSection from "./landing/ContactSection";
import LandingFooter from "./landing/LandingFooter";

export default function Landing() {
  const [record, setRecord] = useState(null);
  useEffect(() => {
    api.get("/public/record").then((r) => setRecord(r.data)).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen landing-bg" data-testid="landing-page">
      <LandingHeader />
      <main className="max-w-6xl mx-auto px-6">
        <Hero />
        <ReturnsTeaser />
        <MembershipProtocol />
        <AccessVectors />
        <WhatWeDoNotPublish />
        <ContactSection />
      </main>
      <LandingFooter record={record} />
    </div>
  );
}
